import {Link} from "react-router-dom";
import './MyStyles.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {usePatAuth} from "../context/PatAuthContext";
const formatDateTime = (dateTimeString) => {
    return new Date(dateTimeString).toLocaleString('en-IN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
};
function PatHeader(props) {
    const {logoutPatient} = usePatAuth();
    const checkPat = localStorage.getItem("pat_login");
    const pat_id = localStorage.getItem("pat_id");
    const patient_id = localStorage.getItem("patient_id");
    const handleLogout = () => {
        logoutPatient();
    };
    return (
        <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
            <div className="container">
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarTogglerDemo01"
                    aria-controls="navbarTogglerDemo01"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
                    {checkPat === "true" ? (
                        <>
                            <Link className="navbar-brand" to="/pat-menu">
                                MGM DrHiS
                            </Link>

                            <ul className="navbar-nav ms-auto">

                                <li className="nav-item">
                                    <Link className="nav-link" to="/pat-menu">
                                        <FontAwesomeIcon icon="fa-solid fa-house-user" size="1x" color="#ffc107"/>
                                    </Link>
                                </li>

                                <li className="nav-item dropdown">

                                    <a
                                        className="nav-link dropdown-toggle"
                                        href="#"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                    >
                                        {pat_id}
                                    </a>

                                    <ul className="dropdown-menu dropdown-menu-end">


                                        <li>
                        <span className="dropdown-item-text">
                          UHID : {patient_id}
                        </span>
                                        </li>

                                        <li>
                                            <Link className="dropdown-item" to={`/pat-vital-details/${pat_id}`}>
                                                Dashboard
                                            </Link>
                                        </li>

                                        <li>
                                            <button
                                                className="dropdown-item"
                                                onClick={handleLogout}
                                            >
                                                Logout
                                            </button>
                                        </li>

                                    </ul>

                                </li>

                            </ul>
                        </>
                    ) : (
                        <>
                        </>
                    )}

                </div>
            </div>
        </nav>
    );
}
export {formatDateTime};
export default PatHeader;
